import React from "react";
import { Button, Label } from "usebeauty";
import classNames from "classnames";
import { useRoutes } from "@router/Router";
import { useOCRContext } from "@context/OCRContext";
import { useFaceContext } from "@context/FaceContext";
import { Back, ChevronLeft, Close, Frown, Smile } from "@Icons";
import "./FaceResultPage.scss";

const FaceResultPage = () => {
  const { step, navigate } = useRoutes();
  const ocrContext = useOCRContext();
  const faceContext = useFaceContext();
  const livenessImages = faceContext.livenessQueue.takeAll();
  const isLive = faceContext.result.liveness.is_live;
  const isMatch = faceContext.result.compare.match_result === 1;

  const mimeType = "data:image/jpeg;base64,";

  const cleanup = () => {
    ocrContext.handlers.reset();
    faceContext.handlers.reset();
  };

  const nextHandler = () => {
    cleanup();
    navigate("next");
  };

  const prevHandler = () => {
    navigate("prev");
  };

  const toFixed = (value: number, fixed = 1) => {
    if (typeof value !== "number") return value;
    const _fixed = 10 ** fixed;
    return Math.round(value * _fixed) / _fixed;
  };

  return (
    <div className="alchera-demo-face-result">
      <div className="navigation">
        {step.prev && (
          <i onClick={() => navigate("prev")}>
            <Back st={{ fontSize: "16px" }} />
          </i>
        )}
        <Label text={step.label}></Label>
        <i onClick={() => window.location.reload()}>
          <Close st={{ fontSize: "16px" }} />
        </i>
      </div>

      <div className="container">
        <div className="image-result">
          <div className="image-container">
            <h4 className="label">신분증 원본</h4>
            <div className="image">
              <img src={mimeType + ocrContext.croppedImage} alt="신분증 원본" />
            </div>
          </div>
          <div className="image-container">
            <h4 className="label">매칭 사진</h4>
            <div className="image">
              <img src={mimeType + faceContext.selfieImage} alt="매칭 사진" />
            </div>
          </div>
        </div>

        <div className="liveness-result">
          <h4 className="label">Liveness촬영본</h4>
          <div className="liveness-images">
            {livenessImages.map((image, i) => (
              <img src={image} alt="" key={i} />
            ))}
          </div>
        </div>

        <div className="face-result">
          <div className="title">
            <h4>인식결과</h4>
          </div>
          <div className="content">
            <ul>
              <li>
                <div>
                  <span className="label">위변조 판별</span>
                  <span className={classNames("value", isLive ? "ssa-true" : "ssa-false")}>
                    {isLive ? "REAL" : "FAKE"}
                  </span>
                </div>
                <div>
                  <span className="label">신뢰도</span>
                  <span className="value">{toFixed(faceContext.result.liveness.confidence, 6)}</span>
                </div>
              </li>
              <li>
                <div>
                  <span className="label">얼굴 매칭</span>
                  <span className={classNames("value", isMatch ? "ssa-true" : "ssa-false")}>
                    {isMatch ? "TRUE" : "FALSE"}
                  </span>
                </div>
                <div>
                  <span className="label">신뢰도</span>
                  <span className="value">{toFixed(faceContext.result.compare.similarity_confidence, 6)}</span>
                </div>
              </li>
            </ul>
            <div className="info">
              {isLive && isMatch ? (
                <>
                  <Smile st={{ fontSize: "16px" }} />
                  <span>
                    매칭되었습니다. <b>다음</b>으로 진행해 주세요!
                  </span>
                </>
              ) : (
                <>
                  <Frown st={{ fontSize: "16px" }} />
                  <span>
                    정확한 본인 확인을 위해 <b>재촬영</b>해 주세요.
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="steps">
          <span>Step 4</span>
          <div className="step">
            <div className="level prev"></div>
            <div className="level prev"></div>
            <div className="level prev"></div>
            <div className="level current"></div>
          </div>
        </div>
        <Button onClick={isLive && isMatch ? nextHandler : prevHandler} ripple={false}>
          <span>{isLive && isMatch ? "다음" : "재촬영"}</span>
          <ChevronLeft st={{ fontSize: "20px" }} />
        </Button>
      </div>
    </div>
  );
};

export default FaceResultPage;
